import request from '@/axios'
import { config } from '@/utils/publicConfig'

const BASE_URL = '/api/common/'
// 获取省市区树
export const getRegionTreeApi = () => {
  return request.get({
    url: `${BASE_URL}region/regionTree`
  })
}

/** menuCode 与 base_menu.code、路由 name 一致；优先于 menuId 解析，避免缓存中的 meta.id 与库不一致 */
export const getTableColumnsApi = (params: { menuId?: string; menuCode?: string }) => {
  return request.get({
    url: `/api/base_web/customColumnsRelation/menuColumns`,
    params
  })
}

// 保存列表表头数据
export const saveTableColumnsApi = (data) => {
  return request.post({
    url: `/api/base_web/customColumnsRelation/batchSaveOrUpdateRelation`,
    data
  })
}

// 获取数据字典详情内容（缓存）
export const getDictApi_p = (code) => {
  return request.get({
    url: `${BASE_URL}dictionary/findDetailByCache`,
    params: {
      dictionaryCode: code
    }
  })
}

// 获取数据字典详情（数据库）
export const getDictApi_db = (code) => {
  return request.get({
    url: `${BASE_URL}dictionary/findDetailsByDicCode`,
    params: {
      dictionaryCode: code
    }
  })
}

// 上传文件
export const uploadFileApi = (data, par) => {
  return request.post({
    url: `${BASE_URL}attachment/upload`,
    data,
    params: {
      ...par
    },
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 查看文件图片（可选资源，失败时不弹全局错误）
export const previewFileApi = (fileId: string, options?: { silentError?: boolean }) => {
  return request.get({
    url: `${BASE_URL}attachment/preview`,
    params: {
      fileId
    },
    responseType: 'blob',
    silentError: options?.silentError ?? true
  })
}

// 获取枚举信息
export const getEnumApi = (code) => {
  return request.get({
    url: `${BASE_URL}enum/batchGetMap`,
    params: {
      enumName: code
    }
  })
}

// 获取文件列表；新库或未配置附件分组时没有 bizId，直接返回空列表，避免后端必填参数异常。
export const getFileListApi = (bizId, bizKind, subKind?) => {
  if (!bizId) {
    return Promise.resolve({
      code: 0,
      data: []
    })
  }

  return request.get({
    url: `${BASE_URL}attachment/listByBizInfo`,
    params: {
      bizId,
      bizKind,
      subKind
    }
  })
}

// 删除图片文件
export const deleteFileApi = (fileId: string) => {
  return request.post({
    url: `${BASE_URL}/attachment/delete`,
    params: {
      fileId
    }
  })
}

// 获取对应的标准车型库枚举值
export const getBaseCarModelEnum = (str: string) => {
  return request.get({
    url: '/api/asset_web/baseCarModel/baseCarModelQueryList',
    params: {
      searchCriteria: str
    }
  })
}

// 同步更新组织机构数据
export const sysUpdateOrgApi = (data) => {
  return request.get({
    url: '/api/base_web/organization/common/synOrg',
    params: data
  })
}

// 同步更新供应商数据
export const sysUpdateSupplierApi = (data) => {
  return request.get({
    url: '/api/base_web/organization/supplier/synSupplier',
    params: data
  })
}

// 同步更新系统用户数据
export const sysUpdateUserApi = (data) => {
  return request.get({
    url: '/api/base_web/user/common/synUser',
    params: data
  })
}
